import React from 'react';
import { Button, Spin } from 'antd';
import { useSalesOrderNotification } from '../../../../../core-module/hooks/useOrdermanagementSignalR';
import { useSingleSalesOrderHistory } from '../../../../../core-module/hooks/useSalesOrderHistory';
import { OrderEditFormContent } from './OrderEditFormContent';

interface Props {
  readonly salesOrderId: string;
  readonly deliveryId: string;
  readonly onHideClick: () => void;
}

const OrderEditFormComponent: React.FC<Props> = ({ salesOrderId, deliveryId, onHideClick }) => {
  const { deliveries, error, loading, refetch } = useSingleSalesOrderHistory(salesOrderId);
  const delivery = deliveries.find((d) => d.deliveryId === deliveryId);

  const { receiveNotification } = useSalesOrderNotification(salesOrderId, {
    throwWhenDisconnected: false,
    throwWhenTimeout: false
  });

  async function handleSalesOrderUpdate() {
    await receiveNotification();
    refetch();
  }

  return (
    <>
      {loading && (
        <div style={{ textAlign: 'center', padding: '0.5em' }}>
          <Spin size='large' tip='Bestelling wordt opgehaald...' />
        </div>
      )}

      {error && (
        <div style={{ textAlign: 'center', padding: '0.5em' }}>
          <p>Er is een fout opgetreden bij het ophalen van de bestelling.</p>
          <Button onClick={onHideClick}>Terug</Button>
          <Button onClick={() => refetch()} style={{ marginLeft: '1em' }}>
            Opnieuw proberen
          </Button>
        </div>
      )}

      {!loading && !error && delivery && (
        <OrderEditFormContent
          delivery={delivery}
          onHideClick={onHideClick}
          handleSalesOrderUpdate={handleSalesOrderUpdate}
        />
      )}
    </>
  );
};

export { OrderEditFormComponent };
